export default __webpack_public_path__ + "static/media/start-up.504e4fdb.svg";